import './App.css';
import Chores from './components/Chores';


window.onload = function() {
  var shouldRefresh = true;
console.log("onload's function that is called just set shouldRefresh to true")
  
//   function refreshPage() {
//   console.log("refreshPage function just started, if(shouldRegresh){window.location.reloud()} just started}. It should say should Refresh == false")
//     if (shouldRefresh) {
//           window.location.reload();
//       }
//   }

//   // Call the function
//   refreshPage();
}


function App() {
  return (
    <div className="App">
<Chores/>


    </div>
  );
}

export default App;
